import Alert from 'cc/Alert'
import ReviewCard from 'cc/ReviewCard'
import { wrapperClasses } from 'components/PageLayouts/BoldHeaderStripe'
import DomainLogo from 'components/DomainLogo'

import Link from 'components/Link'
import { cn, handle } from 'common/utils'
import routes from 'common/routes'
import PageReviewDataTable from 'cc/PageReviewDataTable'

const UserProfileReview = ({
  numDomainReviews = 0,
  numPageReviews = 0,
  uid,
  user,
  profileReview,
}) => {
  const { domainKey, pageKey } = profileReview?.meta || {}

  return domainKey ? (
    <div className={cn(wrapperClasses, 'my-10 md:my-24')}>
      {numDomainReviews === 0 && numPageReviews === 0 ? (
        <Alert variant="info" className="mt-3 text-center">
          {uid === user.id ? "You haven't " : `${handle(user)} hasn't `} yet
          left any reviews.
        </Alert>
      ) : (
        <Link href={routes.reviewPath(user, domainKey, pageKey)}>
          {/* TODO: if review is a page review, link to it directly? */}
          <ReviewCard
            review={profileReview}
            className="bg-white shadow-md rounded-md hover:bg-gray-50"
            user={user}
            onReviewPage
            skipLinks
          >
            <div className="flex space-x-4">
              <DomainLogo
                domainKey={domainKey}
                size={128}
                className="rounded"
              />
              <div className="flex flex-col">
                {pageKey ? (
                  <PageReviewDataTable
                    domainKey={domainKey}
                    pageKey={pageKey}
                  />
                ) : (
                  <div className="text-xl text-gray-600 break-all mt-2">
                    {domainKey}
                  </div>
                )}
              </div>
            </div>
          </ReviewCard>
        </Link>
      )}
    </div>
  ) : null
}

export default UserProfileReview
